export const TestId = {
    BACK_BUTTON: 'back-button',
    USER_CARD: 'user-card',
};
